/**
 * Default map center
 * @see https://www.google.com/maps/place/46.227638,+2.213749/@46.227638,2.213749,15z/data=!4m2!3m1!1s0x0:0x0
 */
export const defaultMapCenter = {
  lat: 46.227638,
  lng: 2.213749,
}
